import Typography from "components/typography";
import React from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa6";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { IconNameConvert } from "../../../countries/iconNameConvert";
import { StoreIconName, storeIcons } from "constants/storeIcons";

interface IProps {
  width: string;
  name: string;
  streams: string;
  type: string;
  percent: string;
}

const PlatformDetails = ({ width, name, streams, type, percent }: IProps) => {
  let iconName = IconNameConvert(name);
  return (
    <Container width={width}>
      <Header>
        <Icon>{storeIcons[iconName as StoreIconName]}</Icon>
        <Typography size="s" color={Colors.grey100}>
          {name}
        </Typography>
      </Header>
      <Details>
        <Typography size="4xl" weight="semibold">
          {Number(streams).toLocaleString()}
        </Typography>
        <PercentContainer type={type}>
          <Typography size="xl" color="inherit" mr="0.5">
            {type === "increase" ? "+" : "-"}
            {percent}%
          </Typography>
          {type === "increase" ? (
            <FaCaretUp size={14} />
          ) : (
            <FaCaretDown size={14} />
          )}
        </PercentContainer>
      </Details>
    </Container>
  );
};

export default PlatformDetails;

const Container = styled.div<{ width: string }>`
  width: ${(props) => `${props.width}%`};
  padding: 1.6rem;
  background: #1e1e1e;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Header = styled.div`
  display: flex;
  margin-bottom: 3rem;
  align-items: center;
  gap: 0.5rem;
`;

const Icon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;

const Details = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: space-between;
`;

const PercentContainer = styled.div<{ type: string }>`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.type === "increase" ? Colors.success : Colors.danger};
`;
